<template>
  <div class="bulk-action__container">
    <div class="flex-between">
      <label class="bulk-action__panel flex-between">
        <input
          ref="selectAllCheck"
          type="checkbox"
          class="checkbox"
          :checked="allContactsSelected"
          :indeterminate.prop="!allContactsSelected"
          @change="selectAll($event)"
        />
        <span>
          {{
            $t('BULK_ACTION.CONTACTS_SELECTED', {
              contactCount: contacts.length,
            })
          }}
        </span>
      </label>
      <div class="bulk-action__actions flex-between mr-10">
        <woot-button
          v-tooltip.top="$t('BULK_ACTION.LABELS.ASSIGN_LABELS')"
          size="tiny"
          variant="smooth"
          color-scheme="secondary"
          icon="tag"
          class="margin-right-smaller"
          @click="toggleLabelActions"
        />
        <woot-button
          v-tooltip.top="$t('BULK_ACTION.CONTACT_STATUS.UPDATE_BOARD_PIPELINE')"
          size="tiny"
          variant="smooth"
          color-scheme="secondary"
          icon="pipeline"
          class="margin-right-smaller"
          @click="toggleStatusActions"
        />
        <woot-button
          v-tooltip.top="$t('BULK_ACTION.ASSIGN_AGENT_TOOLTIP')"
          size="tiny"
          variant="smooth"
          color-scheme="secondary"
          icon="person-assign"
          class="margin-right-smaller"
          @click="toggleAgentList"
          :disabled="isAgent"
        />
      </div>
      <transition name="popover-animation">
        <label-actions
          v-if="showLabelActions"
          class="label-actions-box"
          @assign="assignLabels"
          @close="showLabelActions = false"
        />
      </transition>
      <transition name="popover-animation">
        <contact-agent-selector
          v-if="showAgentsList"
          class="agent-actions-box"
          :contact-count="contacts.length"
          @select="submit"
          @close="showAgentsList = false"
        />
      </transition>
      <transition name="popover-animation">
        <contact-status-actions
          v-if="showStatusActions"
          class="status-actions-box"
          @update-status="updateContactStatus"
          @close="showStatusActions = false"
        />
      </transition>
    </div>
    <div v-if="allContactsSelected" class="bulk-action__alert">
      {{ $t('BULK_ACTION.ALL_CONTACTS_SELECTED_ALERT') }}
    </div>
  </div>
</template>

<script>
import ContactAgentSelector from './ContactAgentSelector.vue';
import LabelActions from '../conversation/conversationBulkActions/LabelActions.vue';
import ContactStatusActions from './ContactStatusActions.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ContactAgentSelector,
    LabelActions,
    ContactStatusActions,
  },
  props: {
    contacts: {
      type: Array,
      default: () => [],
    },
    allContactsSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAgentsList: false,
      showLabelActions: false,
      showStatusActions: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    isAgent() {
      const isAgentRole = this.currentUser?.role === 'agent';
      return isAgentRole;
    },
  },
  methods: {
    selectAll(e) {
      this.$emit('select-all-contacts', e.target.checked);
    },
    submit(agent) {
      this.$emit('assign-agent', agent);
    },
    assignLabels(labels) {
      this.$emit('assign-labels', labels);
    },
    updateContactStatus(statusData) {
      this.$emit('update-status', statusData);
    },
    toggleLabelActions() {
      this.showLabelActions = !this.showLabelActions;
      this.showAgentsList = false;
      this.showStatusActions = false;
    },
    toggleAgentList() {
      this.showAgentsList = !this.showAgentsList;
      this.showLabelActions = false;
      this.showStatusActions = false;
    },
    toggleStatusActions() {
      this.showStatusActions = !this.showStatusActions;
      this.showLabelActions = false;
      this.showAgentsList = false;
    },
  },
};
</script>

<style scoped lang="scss">
// For RTL direction view
.app-rtl--wrapper {
  .bulk-action__actions {
    :deep(.button--only-icon:last-child) {
      margin-right: var(--space-smaller);
    }
  }
}

.bulk-action__container {
  @apply p-4 relative border-b border-solid border-slate-100 dark:border-slate-600/70 bg-white dark:bg-slate-900;
}

.bulk-action__panel {
  @apply cursor-pointer;

  span {
    @apply text-xs my-0 mx-1;
  }

  input[type='checkbox'] {
    @apply cursor-pointer m-0;
  }
}

.bulk-action__alert {
  @apply bg-yellow-50 text-yellow-700 rounded text-xs mt-2 py-1 px-2 border border-solid border-yellow-300 dark:border-yellow-300/10 dark:bg-yellow-200/20 dark:text-yellow-400;
}

.popover-animation-enter-active,
.popover-animation-leave-active {
  transition: transform ease-out 0.1s;
}

.popover-animation-enter {
  transform: scale(0.95);
  @apply opacity-0;
}

.popover-animation-enter-to {
  transform: scale(1);
  @apply opacity-100;
}

.popover-animation-leave {
  transform: scale(1);
  @apply opacity-100;
}

.popover-animation-leave-to {
  transform: scale(0.95);
  @apply opacity-0;
}

// Triangle positioning adjusted to align with updated modal layout
.label-actions-box {
  --triangle-position: 7rem;
}
.status-actions-box {
  --triangle-position: 5rem;
}
.agent-actions-box {
  --triangle-position: 3rem;
}
</style>
